import { render, staticRenderFns } from "./inbound-call-deadend-icon.vue?vue&type=template&id=d0c2e86e"
import script from "./inbound-call-deadend-icon.vue?vue&type=script&lang=js"
export * from "./inbound-call-deadend-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports